import React from "react";

const PageNotFound = () => {
  return (
    <main className="main">
      <section className="w-80 text-center">
        <h3 className="text-brown text-lg">404 Error</h3>
        <h1 className="text-[26px]">Page Not Found</h1>
        <p className="m-4">
          Sorry, the page you are looking for could not be found or has been
          removed
        </p>
      </section>
    </main>
  );
};

export default PageNotFound;
